// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1j-q";
export var animationRelative = "_1j-p";
export var backdropBlur = "_1j-0";
export var detailLabelCell = "_1j-12";
export var detailTable = "_1j-11";
export var detailValueCell = "_1j-13";
export var docIconBox = "_1j-1d";
export var docIconBoxMd = "_1j-1f";
export var docIconBoxSm = "_1j-1e";
export var docTypeRow = "_1j-16";
export var docTypeRowInner = "_1j-17";
export var dropdownMatchDatePicker = "_1j-3";
export var evidenceCardContent = "_1j-1c";
export var fileUploadSpin = "_1j-j";
export var gorgiasOpenButton = "_1j-15 _1j-d";
export var gorgiasTicketCard = "_1j-14";
export var heroModalFooterButton = "_1j-18";
export var hiddenContainer = "_1j-o";
export var iconPrimary = "_1j-1g";
export var iconQuaternary = "_1j-1i";
export var iconTertiary = "_1j-1h";
export var integrationCard = "_1j-1";
export var integrationLogoBox = "_1j-2";
export var mainColumnSticky = "_1j-1b";
export var maxWidthContainer = "_1j-19";
export var modalContentBody = "_1j-a";
export var modalHeaderImage = "_1j-5";
export var modalImageLabel = "_1j-7";
export var modalImageOverlay = "_1j-6";
export var modalImageSubtitle = "_1j-9";
export var modalImageTitle = "_1j-8";
export var modalImageWrapper = "_1j-4";
export var modalStickyFooter = "_1j-b";
export var removeButton = "_1j-e";
export var sidebarColumn = "_1j-1a";
export var spinner = "_1j-i";
export var timelineLine = "_1j-y";
export var timelineLineBlack = "_1j-10 _1j-y";
export var timelineLineGray = "_1j-z _1j-y";
export var timelineLineHeight = "_1j-x";
export var tlDotActivate = "_1j-u";
export var tlDotActivateAnim = "_1j-t";
export var tlDotHide = "_1j-s";
export var tlDotHideAnim = "_1j-r";
export var tlLineActivate = "_1j-w";
export var tlLineActivateAnim = "_1j-v";
export var uploadHint = "_1j-n";
export var uploadIconBox = "_1j-k";
export var uploadLabel = "_1j-m";
export var uploadText = "_1j-l";
export var uploadZone = "_1j-f";
export var uploadZoneCursorDefault = "_1j-h";
export var uploadZoneCursorPointer = "_1j-g";
export var uploadedFileRow = "_1j-c";
export var viewButton = "_1j-d";